import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaWhatsapp } from 'react-icons/fa';

const Header = ({ currentSection }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <div className="nav-container">
        <a href="#home" className="logo" onClick={() => scrollToSection('home')}>
          Sanchiti's Fitness Studio
        </a>
        
        <nav>
          <ul className="nav-menu">
            <li>
              <a 
                href="#home" 
                className={`nav-link ${currentSection === 'home' ? 'active' : ''}`}
                onClick={() => scrollToSection('home')}
              >
                Home
              </a>
            </li>
            <li>
              <a 
                href="#asanas" 
                className={`nav-link ${currentSection === 'asanas' ? 'active' : ''}`}
                onClick={() => scrollToSection('asanas')}
              >
                Yoga Asanas
              </a>
            </li>
            <li>
              <a 
                href="#about" 
                className={`nav-link ${currentSection === 'about' ? 'active' : ''}`}
                onClick={() => scrollToSection('about')}
              >
                About
              </a>
            </li>
            <li>
              <a 
                href="#contact" 
                className={`nav-link ${currentSection === 'contact' ? 'active' : ''}`}
                onClick={() => scrollToSection('contact')}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>

        <div className="social-links">
          <a href="https://facebook.com/sanchitisfitnessstudio" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaFacebook />
          </a>
          <a href="https://instagram.com/sanchitisfitnessstudio" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaInstagram />
          </a>
          <a href="https://twitter.com/sanchitisfitness" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaTwitter />
          </a>
          <a href="https://youtube.com/sanchitisfitnessstudio" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaYoutube />
          </a>
          <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaWhatsapp />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
